import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthProvider';
import { useTheme } from '../contexts/ThemeProvider';
import logoWhite from '../assets/logo-repro-white.svg';
import logoDark from '../assets/logo-repro-v3-dark.svg';

export default function MfaVerify() {
  const { authState, verifyMfa } = useAuth();
  const { resolvedTheme } = useTheme();

  const [totpCode, setTotpCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  if (authState === 'authenticated') return <Navigate to="/dashboard" replace />;
  if (authState !== 'needs_mfa_verify') return <Navigate to="/login" replace />;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await verifyMfa(totpCode);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Invalid code');
      setTotpCode('');
    } finally {
      setLoading(false);
    }
  };

  const logo = resolvedTheme === 'dark' ? logoWhite : logoDark;

  return (
    <div className="min-h-screen flex items-center justify-center bg-base-100 px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <img src={logo} alt="RePro" className="h-8 mx-auto mb-4" />
          <h1 className="text-xl font-semibold text-base-content">Two-Factor Authentication</h1>
          <p className="text-sm text-base-content/60 mt-1">
            Enter the code from your authenticator app
          </p>
        </div>

        <form onSubmit={handleSubmit} className="card bg-base-200 shadow-md">
          <div className="card-body gap-4">
            {error && <div className="alert alert-error text-sm">{error}</div>}

            <div className="form-control">
              <label className="label" htmlFor="totpCode">
                <span className="label-text">Verification Code</span>
              </label>
              <input
                id="totpCode"
                type="text"
                inputMode="numeric"
                pattern="[0-9]{6}"
                maxLength={6}
                required
                autoFocus
                value={totpCode}
                onChange={(e) => setTotpCode(e.target.value.replace(/\D/g, ''))}
                className="input input-bordered w-full text-center tracking-widest font-mono"
                placeholder="000000"
              />
            </div>

            <button
              type="submit"
              disabled={loading || totpCode.length !== 6}
              className="btn btn-primary w-full"
            >
              {loading ? <span className="loading loading-spinner loading-sm" /> : 'Verify'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
